import { Basic } from "../basic.js";
import { Converter } from "../../observer/converter.js";
import "../../lib/leaflet-src-esm.js";
import "../../lib/leaflet-markercluster-src.js"
import "../../lib/Leaflet-DonutCluster.js"
import { toBool, convertToTypesForCompare } from "../../lib/utils.js";
import { Legend } from "./legend/legend.js";

/*<link rel="stylesheet" href="/controls/map/leaflet.css" />
<div id='mapid' class='mapid'></div>*/

//problems:
//reinit markers after map load

export class MSMap extends Basic {
    static get observedAttributes() {
        return super.observedAttributes.concat([
            "paneldatasource",
            "markerstyles",
            "modelrefs",
            "tileserver",
            "tilesubdomains",
            "initpoint",
            "zoom",
            "maxzoom",
            "minzoom",
            "maptype",
            "crs",
            "attribution",
            "doubleclickzoom",
            "ignoremarkerbgclicks",
            "theme",
            "markerposition",
            "isclustered",
            "ringdiagram",
            "clustertextbackground",
            "markerclustercolor",
            "markerclusterfill",
            "maxclusterradius",
            "conditions",
            "clustername",
            "displaylegend",
            "legendname",
            "legendposition"
        ]);
    }

    constructor() {
        super();
        this._mapElement = this.getElementsByClassName("mapid")[0];

        //'http://vec{s}.maps.yandex.net/tiles?l=map&v=4.55.2&z={z}&x={x}&y={y}&scale=2&lang=ru_RU'
        //'https://b.tile.openstreetmap.org/{z}/{x}/{y}.png'
        //'http://tilessputnik.ru/{z}/{x}/{y}.png'
        //
        this._initpoint = [0, 0];
        this.zoom = 2;
        this._maxzoom = 23;
        this._minzoom = 0;
        this._maptype = "0";
        this._doubleclickzoom = true;
        this.theme = "0";
        this.markerposition = "0";
        this._tilesize = 512;
        this._useindex = true;
        this.isclustered = true;
        this.ringdiagram = false;
        this.markerclustercolor = '#000';
        this.markerclusterfill = "rgb(113,255,113)";
        this.maxclusterradius = 80;
        this._markerProps = [
            "X",
            "Y",
            "Z",
            "Tooltip",
            "Width",
            "Height",
            "Opacity",
        ];
        this._markerTypeConst = "MarkerType";

        this.currentMarkers = [];
        this.inited = false;
        this.markerHandlers = this.fillHandlers();

        this.legend = new Legend(this);
        this.append(this.legend.element);
    }

    checkCondition(markerValue, compareType, conditionValue){
        const {operand, val} = convertToTypesForCompare(conditionValue, markerValue)
        switch(compareType){
            case(0):
                return typeof val === 'string' ? val.includes(operand) : false;
            case(1): 
                return val == operand;
            case(2): 
                return val > operand;
            case(3): 
                return val < operand;
            case(4): 
                return val >= operand;
            case(5): 
                return val <= operand;
            case(6): 
                return val != operand;
            default:
                return false
        }
    }

    afterInitialize() {
        if (!this.inited) {
            let uid = (this.uid = Math.floor(Math.random() * 1e8).toString(16));
            this._mapElement.id += `_${uid}`;
            this._Lmap = L.map(`mapid_${this.id}_${uid}`, {
                crs: this.getCRS(this._crs),
                doubleClickZoom: this._doubleclickzoom,
            }).setView(this._initpoint, this.zoom);
            this._Lmap.setMaxZoom(this.maxzoom); // maxzoom может прийти в сеттер тогда, когда ещё нету карты. А он нужен при работе с кластеризацией

            this.initCluster();
            this.individualMarkers = L.layerGroup();

            if (window._enums.Theme[this.theme] === window._enums.Theme.Dark) {
                L.DomUtil.addClass(
                    this._Lmap.getContainer(),
                    "leaflet-container--dark"
                );
            }

            this._Lmap.on("click", this.mapOnClick.bind(this));
            this._Lmap.on("zoom", x => {
                this.SetParameter(
                    "zoom",
                    this._Lmap.getZoom(),
                    false,
                    null,
                    null,
                    "",
                    {
                        beforeCallbackFn: () => {
                            this._interaction = true;
                        },
                        afterCallbackFn: () => {
                            this._interaction = false;
                        },
                    }
                );
            });
            if (this._tileserver && Array.isArray(this._tileserver)) {
                if (this._maptype === "0") {
                    if (this._tileserver.length === 1) {
                        this.createMainTileMap(this._tileserver[0]);
                    } else {
                        let tileArray = [...this._tileserver];
                        let main = tileArray.shift();
                        this.createMainTileMap(main);

                        let options = this.getMapOptions();
                        tileArray.forEach(url =>
                            L.tileLayer(url, options).addTo(this._Lmap)
                        );
                    }
                } else if (this._maptype === "1") {
                    let path = this._tileserver[0];
                    let tileResPath = path.includes("/")
                        ? `resources/${path}`
                        : `resources/${path}/{z}/tile-{x}-{y}.png`;
                    this.createMainTileMap(tileResPath);
                }
            } else if (
                this._maptype === "0" &&
                this.hasAttribute("useyandex")
            ) {
                let layerType = this.getAttribute("useyandex");
                this.createYandexLayer(layerType);
            }
            this.inited = true;
            if (typeof this._paneldatasource !== "undefined") {
                this.processDataSource(this._paneldatasource);
            }
            // Event tab-open для перерисовки и корректной работы карты(вызывается при переключении вкладки в панели вкладок)
            this.addEventListener("tab-open", () => {
                this._Lmap.invalidateSize(false);
                // Event custom-resize для перерисовки конкретно яндекс карт
                if (this._yandexLayer) {
                    this._yandexLayer._container.dispatchEvent(
                        new Event("custom-resize")
                    );
                }
            });
            this.toggleCluster();
        }
    }

    attributeChangedCallback(
        attrName,
        oldVal,
        newVal,
        itemIndex,
        forced,
        sourceAttrName
    ) {
        if (oldVal === newVal) {
            return;
        }

        if (attrName === "paneldatasource") {
            if (
                typeof itemIndex !== "undefined" &&
                typeof sourceAttrName !== "undefined"
            ) {
                let paramStruct = this.modelParamsStruct[sourceAttrName];
                let dsField = paramStruct.FieldName;

                let currentValue = this._paneldatasource[itemIndex][dsField];
                let valueConvert = Converter.convert(
                    paramStruct,
                    currentValue,
                    paramStruct.FieldType
                );
                //исходное значение может быть сконвертировано,
                //тогда значение в источнике данных может отличаться, при том что изменений не было
                //так проверяем конвертацию сохраненного значения и новое значение
                if (newVal != valueConvert) {
                    let value = Converter.convert(
                        paramStruct,
                        newVal,
                        paramStruct.FieldType
                    );
                    this._paneldatasource[itemIndex][dsField] = value;
                    if (typeof this.prop_link.paneldatasource === "function") {
                        this.prop_link.paneldatasource(
                            this.pId ? this.pId + "/" + this.id : this.id,
                            this.Links["paneldatasource"],
                            this._paneldatasource,
                            "paneldatasource",
                            itemIndex
                        );
                    }
                }
            } else {
                this.paneldatasource = newVal;
            }
        } else {
            super.attributeChangedCallback(attrName, oldVal, newVal);
        }
    }

    initCluster(){
        this.markersClusterDiagram = new L.DonutCluster({
            maxClusterRadius: this.maxclusterradius,
            spiderLegPolylineOptions: null,
        }, {
            key: 'groupid',
            arcColorDict: this.groups?.reduce((acc, group) => {
                acc[group.id] = group.color
                return acc;
            }, {}),
            title: this.groups?.reduce((acc, group) => {
                acc[group.id] = group.name;
                return acc;
            }, {}),
            style: {
                fill: this.clustertextbackground,
                opacity: 1,
                size: 50,
                weight: 5,
                textColor: this.markerclustercolor
            },
            format: (value, type) => value.toFixed(type === 'percentage' ? 1 : 0)
        })
        this.markersCluster = L.markerClusterGroup({
            iconCreateFunction: (cluster) => {
                const childmarkers = cluster.getAllChildMarkers()
                const conditions = this.conditions?.markerclusterfillcondition;
                const color = this.markerclustercolor;
                let fill = this.markerclusterfill
                if(conditions){
                    let setedValue = false
                    for(let i = 0; i < conditions.length; i++){
                        if(setedValue){
                            break;
                        }
                        const condition = conditions[i]
                        for(let j = 0; j < childmarkers.length; j++){
                            const marker = childmarkers[j]      
                            if(marker.options && this.checkCondition(marker.options.params[condition.messagefield], condition.comparetype, condition.value)){
                                fill = condition.fill !== 'TRANSPARENT' ? condition.fill : this.markerclusterfill
                                setedValue = true
                                break;
                            }
                        }
                    }
                }
                const childCount = cluster.getChildCount();
                    return new L.DivIcon({ html: `<div style="position: relative; width: 40px; height: 40px; border-radius: 50%; background-color: ${fill};">
                        <div style="position: absolute; top: 5px; left: 5px; width: calc(100% - 10px); height: calc(100% - 10px); border-radius: 50%; background-color: ${this.clustertextbackground}; display: flex; align-items: center; justify-content: center;">
                            <span style="color: ${color};">${childCount}</span>
                        </div>
                    </div>`,
                    className: 'marker-cluster', iconSize: new L.Point(40, 40) });
            },
            maxClusterRadius: this.maxclusterradius,
            spiderLegPolylineOptions: null,
        });
    }

    createMainTileMap(url) {
        let options = this.getMapOptions();
        L.tileLayer(url, options).addTo(this._Lmap);
    }

    createYandexLayer(type) {
        let layer = type || "map";
        let options = this.getMapOptions();
        this._yandexLayer = L.yandex(`yandex#${layer}`, options).addTo(
            this._Lmap
        );
    }

    getMapOptions() {
        let options = {
            maxZoom: this._maxzoom,
            minZoom: this._minzoom,
            reuseTiles: true,
            updateWhenIdle: false,
            subdomains: this._tilesubdomains || "",
            tileSize: this._tilesize,
            zoomOffset: -1,
            attribution: this._attribution,
        };
        return options;
    }

    updateGroup(){
        const newGroups = [{id: 1, name: this.clustername, color: this.markerclusterfill}];
        this.conditions?.markerclusterfillcondition.forEach((item, i) => {
            newGroups.push({id: i + 2, name: item.groupname, color: item.fill})
        })
        this.groups = newGroups
    }

    get width() {
        return this._width;
    }
    set width(value) {
        this._width = value;
        const tmp = Number(value);
        if (tmp) {
            this._mapElement.style.width = this._setValueUnit(value);
        }
    }

    get height() {
        return this._height;
    }
    set height(value) {
        this._height = value;
        const tmp = Number(value);
        if (tmp) {
            this._mapElement.style.height = this._setValueUnit(value);
        }
    }

    get modelrefs() {
        return this._modelrefs;
    }
    set modelrefs(value) {
        try {
            var ds = JSON.parse(value);
        } catch (e) {
            ds = {};
        }
        this._modelrefs = ds;
    }

    get markerstyles() {
        return this._markerstyles;
    }
    set markerstyles(value) {
        try {
            var ds = JSON.parse(value);
        } catch (e) {
            ds = {};
        }
        this._markerstyles = ds;

        if (!this.modelParamsStruct) {
            this.calcModelParams(ds);
        }
    }

    get paneldatasource() {
        return this._paneldatasource;
    }
    set paneldatasource(value) {
        if (value && value.value) {
            this._paneldatasource_dataType = value.dataType;
            var ds = value.value;
        } else {
            try {
                ds = JSON.parse(value);
            } catch (ex) {
                ds = [];
            }
        }
        this._paneldatasource = ds;
        if (this.inited) {
            this.processDataSource(ds);
        }
    }

    get conditions(){
        return this._conditions;
    }
    set conditions(value){
        const con = JSON.parse(value)
        if(con !== undefined && !Array.isArray(con?.markerclusterfillcondition)){
            con.markerclusterfillcondition = [con.markerclusterfillcondition]
        }
        this._conditions = con;
        this.updateGroup()
    }

    get groups() {
        return this._groups;
    }
    set groups(value) {
        this._groups = value;
        this.legend?.render()
    }

    get maptype() {
        return this._maptype;
    }
    set maptype(value) {
        this._maptype = value;
    }

    get tileserver() {
        return this._tileserver;
    }
    set tileserver(value) {
        if (value) {
            let val = value.split(",");
            this._tileserver = val;
        }
    }

    get tilesubdomains() {
        return this._tilesubdomains;
    }
    set tilesubdomains(value) {
        if (value) {
            let val = value.split(",").map(x => x.trim());
            this._tilesubdomains = val;
        }
    }

    get initpoint() {
        return this._initpoint;
    }
    set initpoint(value) {
        let val = [];
        if (value && typeof value === "string") {
            let sp = value.split(",");
            val = sp.map(x => Number(x));
            if (sp.length === 2) {
                this._initpoint = val;
            }
            if (sp.length === 3) {
                this._initpoint = [val[0], val[1]];
                this.zoom = val[2];
            }
            if (typeof this._Lmap !== "undefined") {
                this._Lmap.setView(this._initpoint, this.zoom);
            }
        }
    }

    get maxzoom() {
        return this._maxzoom;
    }
    set maxzoom(value) {
        let val = Number(value);
        if (value !== null && !Number.isNaN(val) && val >= 0) {
            this._maxzoom = val;
            if (typeof this._Lmap !== "undefined") {
                this._Lmap.setMaxZoom(this._maxzoom);
            }
        }
    }

    get minzoom() {
        return this._minzoom;
    }
    set minzoom(value) {
        let val = Number(value);
        if (value !== null && !Number.isNaN(val) && val >= 0) {
            this._minzoom = val;
            if (typeof this._Lmap !== "undefined") {
                this._Lmap.setMinZoom(this._minzoom);
            }
        }
    }

    // Устанавливает текущее значение приближения
    get zoom() {
        return this._zoom || 2;
    }
    set zoom(value) {
        const val = +value;
        if (value !== null && !Number.isNaN(val) && val >= 0) {
            this._zoom = val;

            if (typeof this._Lmap !== "undefined" && !this._interaction) {
                // Если zoom меняется внутри самой карты, например, колесом,
                // то здесь нужно проверить, чтобы this._interaction не была равна true,
                // поскольку во время скролла карты не только отсылается новое значение в DT,
                // но и приходит от него это же самое значение,
                // т.е. этой проверкой мы не даём дважды поменять одно и тоже значение зума у карты
                this._Lmap.setZoom(this._zoom, { animate: true });
            }
        }
    }

    get crs() {
        return this._crs;
    }
    set crs(value) {
        this._crs = value;
    }

    getCRS(value) {
        let num = Number(value);
        switch (num) {
            case 1:
                return L.CRS.EPSG3857;
            case 2:
                return L.CRS.EPSG4326;
            case 3:
                return L.CRS.Simple;
            default:
            case 0:
                return L.CRS.EPSG3395;
        }
    }

    get attribution() {
        return this._attribution;
    }
    set attribution(value) {
        if (value !== null && typeof value !== "undefined") {
            if (typeof this._Lmap !== "undefined") {
                this._Lmap.attributionControl.removeAttribution(
                    this._attribution
                );
                this._attribution = value.toString();
                this._Lmap.attributionControl.addAttribution(this._attribution);
            } else {
                this._attribution = value.toString();
            }
        }
    }

    get doubleclickzoom() {
        return this._doubleclickzoom;
    }
    set doubleclickzoom(value) {
        this._doubleclickzoom = toBool(value);
    }

    // Светлая/Тёмная тема карты:
    // Светлая - 0, Тёмная - 1
    get theme() {
        return this._theme || "0";
    }
    set theme(value) {
        this._theme = value;

        if (!this._Lmap) {
            return;
        }

        const container = this._Lmap.getContainer();
        switch (window._enums.Theme[value]) {
            case window._enums.Theme.Dark: {
                L.DomUtil.addClass(container, "leaflet-container--dark");
                break;
            }
            case window._enums.Theme.Light: {
                L.DomUtil.removeClass(container, "leaflet-container--dark");
                break;
            }
        }
    }

    // Игнорирование кликов по прозрачному фону маркера
    get ignoremarkerbgclicks() {
        return this._ignoremarkerbgclicks ?? false;
    }
    set ignoremarkerbgclicks(value) {
        this._ignoremarkerbgclicks = value;
    }

    // Позиционирование маркеров:
    // По центру - 0,
    // Сверху слева - 1
    // Сверху справа - 1
    // Снизу слева - 1
    // Снизу справа - 1
    get markerposition() {
        return this._markerposition || "0";
    }
    set markerposition(value) {
        this._markerposition = value;

        if (!this._Lmap) {
            return;
        }

        this.currentMarkers.forEach(x => {
            const [w, h] = x.marker.options.icon.options.iconSize;
            x.marker.options.icon.options.iconAnchor = this.getIconAnchor(w, h);
            x.marker.setIcon(x.marker.options.icon);
        });
    }

    get clustertextbackground(){
        return this._clustertextbackground || "rgb(255,255,255)";
    }

    set clustertextbackground(value){
        this._clustertextbackground = value; 
        this.toggleCluster(true);
    }

    get markerclustercolor(){
        return this._markerclustercolor;
    }

    set markerclustercolor(value){
        this._markerclustercolor = value; 
        this.toggleCluster(true);
    }

    get markerclusterfill(){
        return this._markerclusterfill;
    }

    set markerclusterfill(value){
        this._markerclusterfill = value;
        this.updateGroup()
        this.toggleCluster(true);
    }

    get maxclusterradius(){
        return this._maxclusterradius;
    }

    set maxclusterradius(value){
        this._maxclusterradius = value;
        this.toggleCluster(true);
    }

    get isclustered() {
        return this._isclustered;
    }

    set isclustered(value) {
        this._isclustered = toBool(value);
        this.toggleCluster()
    }

    get ringdiagram() {
        return this._ringdiagram;
    }

    set ringdiagram(value) {
        this._ringdiagram = toBool(value);
        this.toggleCluster()
    }

    get clustername() {
        return this._clustername || "";
    }

    set clustername(value) {
        this._clustername = value;
        this.updateGroup()
        this.toggleCluster(true);
    }
    
    get displaylegend() {
        return this._displaylegend;
    }

    set displaylegend(value) {
        this._displaylegend = toBool(value);
        this.legend.setVisible(this._displaylegend)
    }

    get legendname() {
        return this._ringdiagram;
    }

    set legendname(value) {
        this._legendname = value;
        this.legend.changeName(value)
    }

    get legendposition() {
        return this._legendposition;
    }

    set legendposition(value) {
        value = Number(value)
        this._legendposition = value;
        this.legend.setPosition(value)
    }

    toggleCluster(clearCluster){
        if(this.currentMarkers?.length){
            this.currentMarkers.forEach(entry => {
                this.markersCluster.removeLayer(entry.marker);
                this.markersClusterDiagram.removeLayer(entry.marker);
                this.individualMarkers.removeLayer(entry.marker);
            });
        }

        if(this._Lmap){
            this._Lmap.removeLayer(this.individualMarkers);
            this._Lmap.removeLayer(this.markersCluster);
            this._Lmap.removeLayer(this.markersClusterDiagram);
            if(clearCluster){
                this.markersCluster = null
                this.markersClusterDiagram = null
                this.initCluster();
            }
            if (this.isclustered) {
                this._Lmap.addLayer(this.ringdiagram ? this.markersClusterDiagram : this.markersCluster);
            } else {
                this._Lmap.addLayer(this.individualMarkers);
            }
        }

        if(this.paneldatasource?.length) this.createMarkers(this.paneldatasource);
    }

    enableElement() {
        if (typeof this._maskElement !== "undefined") {
            this._maskElement.remove();
            delete this._maskElement;
        }
    }

    disableElement() {
        if (typeof this._maskElement === "undefined") {
            this._maskElement = this.createMaskElement(1500);
            this.appendChild(this._maskElement);
        }
    }

    calcModelParams() {
        let modelParams = { ...this._markerstyles };

        let dsParamsSet = new Set();
        let markerParamsSet = new Set();
        let markerTypeSet = new Set();
        let dsParamsStruct = {};
        let markerParamsStruct = {};
        let markerTypeStruct = {};
        let markerParamsMap = {};
        Object.entries(modelParams).forEach(val => {
            Object.keys(val[1]).forEach(key => {
                if (key == this._markerTypeConst) {
                    markerTypeStruct[key] = val[1][key];
                    markerTypeSet.add(val[0]);
                } else if (this._markerProps.includes(key)) {
                    markerParamsStruct[key] = val[1][key];
                    markerParamsSet.add(val[0]);
                    let fieldName = val[1][key] && val[1][key].FieldName;
                    markerParamsMap[fieldName] = key;
                } else {
                    dsParamsStruct[key.toLowerCase()] = val[1][key];
                    let fieldName = val[1][key] && val[1][key].FieldName;
                    dsParamsSet.add(fieldName);
                }
            });
        });
        this.markerParamsMap = markerParamsMap;
        this.modelParamsStruct = dsParamsStruct;
        this.markerParamsStruct = markerParamsStruct;
        this.markerTypeStruct = markerTypeStruct;
        this.dsParamsArray = Array.from(dsParamsSet);
        this.markerParamsArray = Array.from(markerParamsSet);
        this.typeFieldArray = Array.from(markerTypeSet);
    }

    fillHandlers() {
        let markerHandlers = {};
        markerHandlers["Width"] = this.changeMarkerSize.bind(this, "Width");
        markerHandlers["Height"] = this.changeMarkerSize.bind(this, "Height");
        markerHandlers["X"] = this.changeLocation.bind(this);
        markerHandlers["Y"] = this.changeLocation.bind(this);
        markerHandlers["Z"] = this.changeMarkerZ.bind(this);
        markerHandlers["Tooltip"] = this.changeTooltip.bind(this);
        markerHandlers["Opacity"] = this.changeMarkerOpacity.bind(this);
        return markerHandlers;
    }

    processDataSource(ds) {
        if (ds && Array.isArray(ds)) {
            if (this.needRecreate(ds)) {
                this.removeMarkers();
                this.createMarkers(ds);
            } else {
                this.updateDS(ds);
            }
        }
    }

    needRecreate(ds) {
        return (
            this.currentMarkers.length === 0 ||
            ds.length !== this.currentMarkers.length
        );
    }

    updateDS(ds) {
        const { toRecreate, toMarkerUpdate, toParamsUpdate } =
            this.compareDS(ds);
        if (toRecreate.length > 0) {
            let indexList = toRecreate.map(el => el.index);
            this.removeMarkers(indexList);
            this.createMarkers(toRecreate);
        }
        if (toMarkerUpdate.length > 0) {
            toMarkerUpdate.forEach(obj => {
                this.updateMarker(
                    obj.item,
                    obj.diffKeysUpdate.map(x => this.markerParamsMap[x])
                );
            });
            this.toggleCluster(true);
        }
        if (toParamsUpdate.length > 0) {
            toParamsUpdate.forEach(item => {
                let markerEntry = this.currentMarkers[item.index];
                if (typeof markerEntry !== "undefined") {
                    if(markerEntry.marker?.options?.params !== undefined){
                        markerEntry.marker.options.params = item
                        if(this.ringdiagram){
                            this.isclustered && this.markersClusterDiagram.refreshClusters();
                        } else {
                            this.isclustered && this.markersCluster.refreshClusters();
                        }
                    }
                    if (markerEntry.hasParams) {
                        let { msWin } = this.getMarkerModels(
                            markerEntry.marker
                        );
                        this.setWindParams(msWin, item);
                        //TODO: set only different keys
                    }
                    if (markerEntry.popupOpened) {
                        this.setPopupParams(item.index);
                    } else {
                        this.removeMarkers([item.index])
                        this.createMarkers([item])
                    }
                }
            });
        }
    }

    compareDS(ds) {
        let toRecreate = [],
            toParamsUpdate = [],
            toMarkerUpdate = [];
        let temp = [];

        ds.forEach((el, index) => {
            el.index = index;
            let markerEntry = this.currentMarkers[index];
            if (typeof markerEntry !== "undefined") {
                let storedItem = markerEntry.item;
                if (
                    typeof storedItem !== "undefined" &&
                    !this.compareEntry(el, storedItem, this.typeFieldArray)
                ) {
                    toRecreate.push(el);
                } else {
                    temp.push(el);
                }
            }
        });
        temp.forEach(el => {
            let markerEntry = this.currentMarkers[el.index];
            if (typeof markerEntry !== "undefined") {
                let storedItem = markerEntry.item;
                if (typeof storedItem !== "undefined") {
                    if(JSON.stringify(el) !== JSON.stringify(storedItem)){
                        let diffKeysUpdate = this.getDiffKeys(
                            el,
                            storedItem,
                            this.markerParamsArray
                        );
                        if (diffKeysUpdate.length > 0) {
                            toMarkerUpdate.push({ item: el, diffKeysUpdate });
                        }
                    }
                    if (
                        !this.compareEntry(el, storedItem, this.dsParamsArray)
                    ) {
                        toParamsUpdate.push(el);
                    }
                }
            }
        });

        //then update current markers stored items
        ds.forEach(el => {
            this.currentMarkers[el.index].item = { ...el };
        });

        return {
            toRecreate,
            toMarkerUpdate,
            toParamsUpdate,
        };
    }

    compareEntry(newItem, oldItem, keys = Object.keys(oldItem)) {
        // true if values are equal
        return keys.reduce(
            (acc, cur) => this.deepCompareByKey(newItem, oldItem, cur) && acc,
            true
        );
    }

    getDiffKeys(newItem, oldItem, keys = Object.keys(oldItem)) {
        //returns array of changed fields
        return keys.filter(
            cur => !this.deepCompareByKey(newItem, oldItem, cur)
        );
    }

    deepCompareByKey(newItem, oldItem, key) {
        if (this.markerParamsArray.includes(key)) {
            return false;
        }
        let newItemValue = this.extractItemValue(key, newItem);
        let oldItemValue = this.extractItemValue(key, oldItem);
        return newItemValue == oldItemValue;
    }

    createMarkers(ds) {
        let useIndexFlag = this._useindex;
        ds.forEach((item, ind) => {
            let markerId;
            if (useIndexFlag) {
                let { index } = item;
                markerId = index || ind;
            } else {
                markerId = item.Id; //TODO:resolve Id field
            }
            item.index = markerId;
            this.createMarker({ ...item }, markerId);
        });
    }

    removeMarkers(indexArray) {
        if (indexArray && indexArray.length > 0) {
            indexArray.forEach(ind => {
                let markerEntry = this.currentMarkers[ind];
                if (typeof markerEntry !== "undefined") {
                    const marker = markerEntry.marker
                    this.markersCluster.removeLayer(marker);
                    this.markersClusterDiagram.removeLayer(marker);
                    this.individualMarkers.removeLayer(marker);
                }
            });
        } else {
            this.currentMarkers.forEach(entry => {
                this.markersCluster.removeLayer(entry.marker);
                this.markersClusterDiagram.removeLayer(entry.marker);
                this.individualMarkers.removeLayer(entry.marker);
            });
            this.currentMarkers = [];
        }
    }

    updateMarker(item, diffKeys) {
        let markerEntry = this.currentMarkers[item.index];
        if (
            typeof markerEntry !== "undefined" &&
            typeof markerEntry.marker !== "undefined"
        ) {
            for (let i = 0; i < diffKeys.length; i++) {
                let key = diffKeys[i];
                this.markerHandlers[key](markerEntry.marker, item);
            }
        }
    }

    changeMarkerSize(side, marker, item) {
        let icon = marker._icon;
        if (typeof icon !== "undefined") {
            let val = this.getMarkerParamDSValue(side, item);
            if (typeof val !== "undefined" && val !== null) {
                const prop = side.toLowerCase();    
                icon.style[prop] = val;
                const frame = icon.firstChild;
                if (frame?.nodeName === "MS-FRAME") {
                    frame[prop] = val;
                }
            }
        }
    }

    changeLocation(marker, item) {
        let location = this.getLocation(item);
        marker.setLatLng(location);
    }

    changeMarkerZ(marker, item) {
        let z = this.getMarkerParamDSValue("Z", item);
        if (typeof z !== "undefined") {
            marker.setZIndexOffset(Number(z));
        }
    }

    changeTooltip(marker, item) {
        let tooltip = this.getMarkerParamDSValue("Tooltip", item);
        if (
            tooltip &&
            (typeof marker._tooltip === "undefined" ||
                tooltip != marker._tooltip._content)
        ) {
            marker.bindTooltip(tooltip);
        }
    }

    changeMarkerOpacity(marker, item) {
        let opacity = this.getMarkerParamDSValue("Opacity", item);
        if (typeof opacity !== "undefined") {
            marker.setOpacity(opacity / 100);

            let disabled = Number(opacity) === 0 && opacity !== null;

            this.setDisable(item.index, disabled);
            let { msWin } = this.getMarkerModels(marker);
            let isActive = typeof msWin === "undefined" || this.isActive(msWin);

            this.toggleCursorStyle(item.index, !disabled && isActive);
        }
    }

    setDisable(markerId, disabled) {
        let markerEntry = this.currentMarkers[markerId];
        if (typeof markerEntry !== "undefined") {
            markerEntry.disabled = disabled;
        }
    }

    getMarkerParam(key) {
        if (this._markerProps.includes(key) && this.markerParamsStruct[key]) {
            return this.markerParamsStruct[key];
        } else if (key == this._markerTypeConst && this.markerTypeStruct[key]) {
            return this.markerTypeStruct[key];
        }
    }

    getMarkerParamDSValue(key, item, convert = true) {
        let struct = this.getMarkerParam(key);
        if (typeof struct !== "undefined") {
            return this.getDSItemValue(struct, item, convert);
        }
    }

    getDSItemValue(struct, item, convert) {
        let fieldName = struct.FieldName;
        let value = this.extractItemValue(fieldName, item);
        if (convert && typeof value !== "undefined") {
            return Converter.convert(struct, value, struct.FieldType);
        } else {
            return value;
        }
    }

    extractItemValue(path, item) {
        if (typeof item === "object" && item !== null) {
            let keys = path.split(".");
            if (keys.length === 1) {
                return item[keys[0]];
            } else {
                let result = { ...item };
                let i = 0;
                while (typeof keys[i] !== "undefined") {
                    result = result[keys[i]];
                    i++;
                }
                return result;
            }
        }
    }

    setWindParams(windRef, item, popup) {
        if (typeof this.modelParamsStruct !== "undefined") {
            Object.entries(this.modelParamsStruct).forEach(val => {
                let key = val[0];
                let struct = val[1];
                let itemValue = this.getDSItemValue(struct, item, true);
                if (popup) {
                    if (
                        windRef.hasAttribute(key) &&
                        !windRef.constructor.observedAttributes.includes(key)
                    ) {
                        windRef.SetParameter(key, itemValue, true);
                    }
                } else {
                    if (
                        windRef.hasAttribute(key) ||
                        windRef.constructor.observedAttributes.includes(key)
                    ) {
                        windRef.SetParameter(key, itemValue, true);
                    }

                    this.toggleCursorStyle(item.index, this.isActive(windRef));
                }
            });
        }
    }

    getLocation(item) {
        let x, y;
        if (true /*настройка карты про формат координат*/) {
            x = this.getMarkerParamDSValue("X", item);
            y = this.getMarkerParamDSValue("Y", item);
        }
        return [y, x]; //lat long
        //значение y - lattitude - широта (значение 0 - экватор)
        //значение x - longitude - долгота (значение 0 - нулевой меридиан)
    }

    createMarker(item, markerId) {
        let markerEntry = { item, hasParams: false };
        this.currentMarkers[markerId] = markerEntry;
        let location = this.getLocation(item);
        let mTypeDef = this.getMarkerParamDSValue(this._markerTypeConst, item);
        const conditions = this.conditions?.markerclusterfillcondition;
        let groupid = 1;
        if(conditions){
            let setedValue = false
            for(let i = 0; i < conditions.length; i++){
                if(setedValue){
                    break;
                }
                const condition = conditions[i] 
                if(item && this.checkCondition(item[condition.messagefield], condition.comparetype, condition.value)){
                    groupid = i + 2;
                    setedValue = true
                }
            }
        }
        if (typeof mTypeDef !== "undefined") {
            if (this._modelrefs && this._modelrefs[mTypeDef]) {
                const modelId = this._modelrefs[mTypeDef];
                let winModel = $WinDefs.winDef[modelId];
                if (winModel) {
                    markerEntry.marker = L.marker(location, {
                        icon: L.divIcon({
                            html: this.createFramedWindow(winModel, undefined, item),
                            iconSize: [winModel.width, winModel.height],
                            iconAnchor: this.getIconAnchor(
                                winModel.width,
                                winModel.height
                            ),
                        }),
                        params: item,
                        groupid
                    })
                    markerEntry.marker.on('add', (e) => {
                        const iconElement = e.target._icon;
                        if (iconElement) {
                            let { msWin } = this.getMarkerModels(markerEntry.marker);
                            this.setWindParams(msWin, item);
                        }
                    });
                    if(this.ignoremarkerbgclicks) {
                        markerEntry.marker.on('add', (e) => {
                            const iconElement = e.target._icon;
                            if (iconElement) {
                                let { msWin } = this.getMarkerModels(markerEntry.marker);
                                    const winChildren = msWin.children;
                                    for (let winChild of winChildren) {
                                        winChild.isenabled = true;
                                        winChild.addEventListener("click", (e) => {
                                            e.stopPropagation();
                                            this.markerOnClick(markerId)
                                    });
                                }
                            }
                        });
                    } else {
                        markerEntry.marker.on(
                            "click",
                            this.markerOnClick.bind(this, markerId)
                        );
                    }
                }
            } else if (mTypeDef.toString().includes(".")) {
                //resolve resource for marker picture
                let iconObj = this.getMarkerIcon(mTypeDef);
                if (typeof iconObj !== "undefined") {
                    const { path, size } = iconObj;
                    if (this.ignoremarkerbgclicks) {
                        markerEntry.marker = L.marker(location, {
                            icon: L.divIcon({
                                html: `<object data="${path}" style="max-width: 100%; max-height: 100%;" type="image/svg+xml"></object>`,
                                iconSize: iconObj.size,
                                iconAnchor: this.getIconAnchor(
                                    size[0],
                                    size[1]
                                ),
                            }),
                            params: item,
                            groupid
                        })
                        markerEntry.marker.on('add', (e) => {
                            const markerElement = markerEntry.marker.getElement();
                            const object = markerElement.firstChild;
                            object.addEventListener("load", () => {
                                const svgTags =
                                    "circle, ellipse, image, rect, line, path, polygon, polyline, text";
                                object.contentDocument.documentElement
                                    .querySelectorAll(svgTags)
                                    .forEach(x => {
                                        x.style.cursor = "pointer";
                                        x.addEventListener("click", (e) => {
                                            e.stopPropagation();
                                            this.markerOnClick(markerId)
                                        });
                                });
                            });
                        })
                    } else {
                        markerEntry.marker = L.marker(location, {
                            icon: L.icon({
                                iconUrl: iconObj.path,
                                iconSize: iconObj.size,
                                iconAnchor: this.getIconAnchor(
                                    iconObj.size[0],
                                    iconObj.size[1]
                                ),
                            }),
                            params: item,
                            groupid
                        })

                        markerEntry.marker.on(
                            "click",
                            this.markerOnClick.bind(this, markerId)
                        );
                    }
                }
            }
        }

        if (typeof markerEntry.marker === "undefined") {
            markerEntry.marker = L.marker(location, {
                params: item,
                groupid
            })
            markerEntry.marker.on(
                "click",
                this.markerOnClick.bind(this, markerId)
            );
        }

        this.markersCluster.addLayer(markerEntry.marker);
        this.markersClusterDiagram.addLayer(markerEntry.marker);
        this.individualMarkers.addLayer(markerEntry.marker);

        //update markers by array of keys [Z, Width, Height, Tooltip, Opacity]
        this.updateMarker(item, this._markerProps.slice(2));
    }

    getIconAnchor(width, height) {
        switch (window._enums.PositionType[this.markerposition]) {
            case window._enums.PositionType.Center: {
                return [width / 2, height / 2];
            }
            case window._enums.PositionType.TopLeft: {
                return [0, 0];
            }
            case window._enums.PositionType.TopRight: {
                return [width, 0];
            }
            case window._enums.PositionType.BottomLeft: {
                return [0, height];
            }
            case window._enums.PositionType.BottomRight: {
                return [width, height];
            }
            default: {
                throw new Error(`Передан недействительный параметр: ${window._enums.PositionType[this.markerposition]
                    },
                Ожидается тип: ${window._enums.PositionType}`);
            }
        }
    }

    getMarkerIcon(mTypeDef) {
        let resName,
            size = [40, 40];
        let spl = mTypeDef.split(".");
        resName = spl[0];
        if (spl.length === 3) {
            try {
                size = spl[1].split("x");
            } catch (e) {
                size = [40, 40];
            }
        }
        let path = this.getResourceFromList(resName);
        if (typeof path !== "undefined") {
            return { path: `resources/${path}`, size };
        }
    }

    createFramedWindow(obj, options, item) {
        let param = "";
        const keys = Object.keys(obj); 
        keys.forEach(key => {
            if (key !== "windowTriggers") {
                param += ` ${key}="${obj[key]}"`;
            }
        });
        if(item){
            const obj2 = {};
            if (typeof this.modelParamsStruct !== "undefined") {
                Object.entries(this.modelParamsStruct).forEach(val => {
                    let key = val[0];
                    let struct = val[1];
                    let itemValue = this.getDSItemValue(struct, item, true);
                    obj2[key] = itemValue;
                });
            }
            const keys2 = Object.keys(obj2);
            keys2.forEach(key => {
                if (key !== "windowTriggers") { 
                    param += ` ${key}="${obj2[key]}"`;
                }
            });
        }
        let frameParam = " borderthickness='0'";
        if (typeof options !== "undefined") {
            frameParam += " x='0'";
            frameParam += ` y='${-this.getFrameEdge(obj, options, "height")}'`;
            frameParam += ` width='${this.getFrameEdge(
                obj,
                options,
                "width"
            )}'`;
            frameParam += ` height='${this.getFrameEdge(
                obj,
                options,
                "height"
            )}'`;
        } else {
            frameParam += ` width='${obj.width}'`;
            frameParam += ` height='${obj.height}'`;
        }
        return `<ms-frame ${frameParam}><ms-window${param} position='absolute'></ms-window></ms-frame>`;
    }

    getFrameEdge(wind, action, key) {
        let result;
        if (action.sizetocontent === 0) {
            result = wind[key];
        } else if (action.sizetocontent === 1) {
            const scaleY = Number(action.height) / Number(wind.height);
            const scaleX = Number(action.width) / Number(wind.width);
            const scale = scaleX > scaleY ? scaleY : scaleX;
            result = scale * wind[key];
        } else {
            result = action[key] || wind[key];
        }
        return result;
    }

    toggleCursorStyle(markerId, active) {
        let markerEntry = this.currentMarkers[markerId];

        if (
            typeof markerEntry !== "undefined" &&
            typeof markerEntry.marker !== "undefined"
        ) {
            let node = markerEntry.marker._icon;
            if (typeof node !== "undefined") {
                //disabled by opacity
                let disabled =
                    typeof markerEntry.disabled === "boolean" &&
                    markerEntry.disabled;

                if (active && !disabled) {
                    node.style.cursor = "pointer";
                    node.style.pointerEvents = "auto";
                } else {
                    node.style.cursor = "grab";
                    node.style.pointerEvents = "none";
                    this.closePopup(markerId);
                }
            }
        }
    }

    isActive(windNode) {
        return windNode.isenabled && windNode.isvisible;
    }

    mapOnClick(ev) {
        if (
            typeof this._actionslist.mapclick !== "undefined" &&
            this._actionslist.mapclick.length > 0
        ) {
            let cusEv = new CustomEvent("mapclick", {
                detail: { x: ev.latlng.lng, y: ev.latlng.lat },
            });
            this.dispatchEvent(cusEv);
        }
    }

    markerOnClick(id) {
        if (
            typeof this._actionslist.markerclick !== "undefined" &&
            this._actionslist.markerclick.length > 0
        ) {
            let { item, marker, popupOpened, disabled } =
                this.currentMarkers[id];
            if (!disabled) {
                let { msWin } = this.getMarkerModels(marker);
                if (
                    (typeof msWin === "undefined" || this.isActive(msWin)) &&
                    typeof item !== "undefined"
                ) {
                    let mtype = this.getMarkerParamDSValue(
                        this._markerTypeConst,
                        item,
                        false
                    );
                    const { lng: x, lat: y } = marker.getLatLng();
                    let cusEv = new CustomEvent("markerclick", {
                        detail: {
                            id,
                            item,
                            markerType: mtype,
                            x,
                            y,
                            popupOpened,
                        },
                    });
                    this.dispatchEvent(cusEv);
                }
            }
        }
    }

    openMarkerWindow(markerId, options) {
        let markerEntry = this.currentMarkers[markerId];
        if (typeof markerEntry !== "undefined") {
            const winId = options.windowid;
            let winModel = $WinDefs.winDef[winId];
            if (!markerEntry.popupOpened && winModel && markerEntry.marker) {
                let wind = this.createFramedWindow(winModel, options);
                let opt = {
                    autoClose: options.closeonnewwindow,
                    closeOnClick: options.closeonlostfocus,
                    closeButton: true,
                };
                markerEntry.marker.bindPopup(wind, opt).openPopup();
                markerEntry.popupOpened = true;
                let { sizetocontent } = options;
                this.setPopupParams(markerId, sizetocontent);
                this.setCloseButton(
                    markerEntry.marker._popup,
                    winModel,
                    options
                );
                markerEntry.marker.on(
                    "popupclose",
                    this.closePopup.bind(this, markerId)
                );
            }
            return markerEntry.marker;
        }
    }

    closePopup(markerId) {
        let markerEntry = this.currentMarkers[markerId];
        if (
            typeof markerEntry !== "undefined" &&
            typeof markerEntry.marker !== "undefined" &&
            markerEntry.popupOpened
        ) {
            markerEntry.popupOpened = false;
            markerEntry.marker.closePopup();
            markerEntry.marker.unbindPopup();
        }
    }

    setPopupParams(markerId, stc) {
        let markerEntry = this.currentMarkers[markerId];
        if (typeof markerEntry !== "undefined") {
            let { msFrame, msWin } = this.getPopupModels(markerEntry.marker);
            if (typeof stc !== "undefined") {
                msFrame.sizetocontent = stc;
            }
            this.addTargets(msWin, markerId);
            this.setWindParams(msWin, markerEntry.item, true);
        }
    }

    setCloseButton(popup, win, options) {
        if (typeof popup === "undefined") return;

        let width = this.getFrameEdge(win, options, "width");
        let height = this.getFrameEdge(win, options, "height");
        let frame = popup._contentNode.firstChild;
        let offset = -Number(height);
        frame.y = offset;
        if (typeof width !== "undefined" && typeof height !== "undefined") {
            popup._closeButton.style.left = Number(width) - 20;
            popup._closeButton.style.top = offset;
            popup._closeButton.style.zIndex = "100";
        }
        if (options.canclose) {
            popup._closeButton.style.display = "block";
        } else {
            popup._closeButton.style.display = "none";
        }
    }

    addTargets(msWin, markerId) {
        let map = this;
        Object.keys(this.modelParamsStruct).forEach(key => {
            if (msWin.hasAttribute(key)) {
                if (typeof msWin.Links[key] !== "undefined") {
                    msWin.Links[key].Targets.push({
                        el: map,
                        //HasBackward:false,
                        ItemId: map.id,
                        OneTime: false,
                        Operation: "move",
                        PropertyPath: "PanelDataSource",
                        Type: "client",
                        ItemIndex: markerId,
                    });
                }
            }
        });
    }

    getPopupModels(marker) {
        if (
            typeof marker !== "undefined" &&
            typeof marker._popup !== "undefined"
        ) {
            var msFrame = marker._popup._contentNode.firstChild;
            var msWin = (msFrame._msWin = msFrame && msFrame.firstChild);
        }
        return { msFrame, msWin };
    }

    getMarkerModels(marker) {
        let msFrame = marker._icon.firstChild,
            msWin;
        if (msFrame !== null) {
            msWin = msFrame._msWin = msFrame && msFrame.firstChild;
        }
        return { msFrame, msWin };
    }
}
